import { render } from "./AppBadge.vue?vue&type=template&id=a7e49172&scoped=true&ts=true"
import script from "./AppBadge.vue?vue&type=script&lang=ts"
export * from "./AppBadge.vue?vue&type=script&lang=ts"

import "./AppBadge.vue?vue&type=style&index=0&id=a7e49172&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7e49172"]])

export default __exports__